/**
 * Словарь уровня логов, используется в ELK-логах
 *
 * @export
 * @enum {number}
 */
var LogLevel;
(function (LogLevel) {
    LogLevel["Error"] = "error";
    LogLevel["Fatal"] = "fatal";
    LogLevel["Trace"] = "trace";
    LogLevel["Debug"] = "debug";
    LogLevel["Info"] = "info";
    LogLevel["Warning"] = "warning";
    LogLevel["Off"] = "off";
})(LogLevel || (LogLevel = {}));
/**
 * Уровень логирования по примеру pino {@see https://github.com/pinojs/pino/blob/master/docs/api.md}
 * Представление в `int` полезно тем, что можно выстроить иерархию между логами, например, если
 * уровень логирования `info`, значит `error` тоже логируется, а `debug` нет
 */
const LogLevelInt = {
    [LogLevel.Trace]: 10,
    [LogLevel.Debug]: 20,
    [LogLevel.Info]: 30,
    [LogLevel.Warning]: 40,
    [LogLevel.Error]: 50,
    [LogLevel.Fatal]: 60,
    [LogLevel.Off]: 70,
};

export { LogLevel, LogLevelInt };
//# sourceMappingURL=ILog.js.map
